import { useEffect, useRef, useState } from 'react';

import { Button } from '@client:common/button';
import { Ripple } from '@client:common/effects/ripple';
import { Form, FormControl, FormGroup, ShortTextFormField } from '@client:common/form';
import { Validators } from '@client:common/form/validation';
import './EmailCollector.dark.scss';
import './EmailCollector.light.scss';

interface Props {
  onSubmit: (email: string) => void;
}

export function EmailCollector(props: Props) {
  const formGroupRef = useRef(new FormGroup({
    email: new FormControl('', [Validators.checkValidEmail()])
  }));
  const onSubmit = () => {
    props.onSubmit(formGroupRef.current.getValue().email);
  };
  const [isFormValid, setIsFormValid] = useState(formGroupRef.current.isValid());

  useEffect(() => {
    const subscription = formGroupRef.current.validityChanges()
      .subscribe({
        next: setIsFormValid
      });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <div className='email-collector'>
      <header>
        <h2>Please enter the email associated with your account</h2>
      </header>
      <Form
        className='email-collector__form'
        formGroup={formGroupRef.current}
        onSubmit={onSubmit}>
        <ShortTextFormField
          label='Email'
          type='email'
          formControl={formGroupRef.current.findControl('email')} />
        <Button
          style='raised'
          color='primary'
          disabled={!isFormValid}
          onClick={onSubmit}>
          <Ripple />
          SUBMIT
        </Button>
      </Form>
    </div>
  );
}
